import { ErrorModal } from '@dekafvv/sharedfrontend';
import { useLanguage } from '@hydrogen/elements.core.i18n';
import { logout } from 'utils/jwtToken';
import { resetUser } from 'redux/auth/authActions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { isAuthenticatedSelector } from 'redux/auth/authSelectors';
import { mutationLogout } from 'shared/Api/model/auth/queries';
import { useClientPortfolioIds } from 'components/InvestmentDetails/hooks';

type Props = {
    hideError: () => void;
}

export const ErrorBoundaryModal = ({ hideError }: Props) => {
    const { t } = useLanguage();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isAuthenticated = useSelector(isAuthenticatedSelector);

    const { clientId } = useClientPortfolioIds();

    const {
        mutateAsync: mutateLogout,
    } = mutationLogout({
        onSuccess: () => {
            logout(navigate);
            dispatch(resetUser());
            hideError();
        },
    });

    const handleLogoutClick = () => {
        if (isAuthenticated) mutateLogout(clientId);
    };

    return (
        <ErrorModal
            heading={t('error.warning1')}
            message={t('error.technical-error1')}
            visible
            button={{
                onClick: () => {
                    window.location.href = '/';
                },
                title: t('button.dashboard'),
            }}
            buttonSecond={{
                onClick: handleLogoutClick,
                title: t('common.logout'),
            }}
        />
    );
};
